import Footer from "./components/common/Footer";
import Navbar from "./components/common/Navbar";
import Swap from "./components/pages/Swap";
import LinkIcons from "./components/common/LinkIcons";
import "./App.css";
import React, { useState, useEffect } from "react";
import {
  getUserData,
  convertTokens,
} from "./components/services/transactions.service";
import {
  ArwesThemeProvider,
  StylesBaseline,
  LoadingBars,
  Text,
} from "@arwes/core";
import { AnimatorGeneralProvider } from "@arwes/animation";
import { BleepsProvider } from "@arwes/sounds";
import {
  FONT_FAMILY_ROOT,
  audioSettings,
  playersSettings,
  bleepsSettings,
  animatorGeneral,
} from "./constants/theme.constants";
import networks from "./components/assets/networks.json";

export default function App() {
  const [web3, setWeb3] = useState({
      network: networks[5],
      networks,
      chainId: 1,
      chainList: [1666600000, 1, 250, 43114, 56, 137],
      message: "Loading...",
    }),
    [showLink, setShowLink] = useState(false);

  useEffect(async () => {
    if (window.ethereum) {
      const addListeners = () => {
        window.addEventListener("load", async (event) => {
          setWeb3(await getUserData(true));
          window.ethereum.on("message", (msg) => console.message(msg));
          window.ethereum.on("chainChanged", (msg) => {
            window.location.reload();
          });
          window.ethereum.on("connect", async (msg) => {
            setWeb3(await getUserData(true));
          });
          window.ethereum.on("disconnect", (msg) => {});
          window.ethereum.on("accountsChanged", (msg) => {
            window.location.reload();
          });
          window.ethereum.on("transactionHash", (hash) => {});
          window.ethereum.on("receipt", function (receipt) {
            console.message(receipt);
          });
        });
      };

      addListeners();
    } else {
      setWeb3(await getUserData(false));
      console.error("Error: MetaMask Ethereum Service Not Found!");
      setTimeout(() => setShowLink(true), 3000);
    }
  }, []);

  return (
    <>
      <ArwesThemeProvider>
        <BleepsProvider
          audioSettings={audioSettings}
          playersSettings={playersSettings}
          bleepsSettings={bleepsSettings}
        >
          <StylesBaseline
            styles={{
              body: { fontFamily: FONT_FAMILY_ROOT },
            }}
          />

          <AnimatorGeneralProvider animator={animatorGeneral}>
            {web3?.message === "Loading..." ? (
              <div className="p-4 grid">
                <div className="load-positioner"></div>
                <center>
                  {showLink ? (
                    <a
                      href="https://metamask.io/"
                      target="_blank"
                      rel="noreferrer"
                      className="animate-pulse text-xl"
                    >
                      <img
                        className="h-16 w-16 m-4"
                        src="https://pages.consensys.net/hubfs/metamask-fox.png"
                        alt="metamask"
                      />
                      <Text>Click to Install MetaMask</Text>
                    </a>
                  ) : (
                    <div
                      className="cursor-pointer"
                      onClick={() => window.location.reload()}
                    >
                      <LoadingBars animator={true} size={2} speed={6} />
                    </div>
                  )}
                </center>
              </div>
            ) : (
              <>
                <Navbar />
                <div className="grid grid-cols-1 pt-16">
                  <center className="col-span-12">
                    <div className={`w-full md:w-11/12 lg:w-10/12`}>
                      <Swap web3={web3} />
                    </div>
                  </center>
                </div>
                <div className="footer-style">
                  <Footer />
                </div>
              </>
            )}
          </AnimatorGeneralProvider>
        </BleepsProvider>
      </ArwesThemeProvider>
    </>
  );
}
